<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      append-to-body
      width="30%"
      center
      @close="closeDialog"
    >
      <div class="result" style="text-align: center">
        <div style="margin: 20px 0"></div>
        <el-form :model="baseInfoData" :rules="rules" ref="closeReasonForm" label-width="120px">
          <el-form-item :label="label" prop="cause">
            <el-input v-model="baseInfoData.cause"></el-input>
          </el-form-item>
          <!-- <i class="el-icon-upload2 el-icon-left"></i> -->
          <el-form-item label="附件" prop="file">
            <!-- <el-button icon="el-icon-upload2">上传附件</el-button> -->
            <!-- <IELUploadBtn
              :fileType="fileType"
              @upload="uploadHandler"
              text="上传附件"
            ></IELUploadBtn> -->
            <el-upload
              ref="upload"
              class="upload-demo"
              style="display: inline-block; margin-right: 10px"
              :action="actionUrl"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :on-preview="handlePreview"
              :data="{ access_token: userInfo.access_token, path: 'scm/maindata' }"
              multiple
              :auto-upload="true"
              :on-progress="handleProgress"
              :on-success="handleSuccess"
              :on-change="uploadChange"
            >
              <el-button icon="el-icon-upload2" size="small" class="vxe-btn-save" ref="btn"
                >上传文件</el-button
              >
            </el-upload>
            <div>支持扩展名{{ fileType.join(',') }}</div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleSure(true)">提交审批</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import API from '@/api/property/leaseContract';
  import XEUtils from 'xe-utils/methods/xe-utils';
  import baseUrl from '@/common/config';
  import dataBaseAPI from '@/api/dataBase';
  import path from 'path';
  export default {
    name: 'btnDialog',
    data() {
      return {
        dialogVisible: false,
        // attachments: [],
        actionUrl: '',
        baseInfoData: { cause: '', attachments: [] },
        cause: '',
        ids: [],
        fileType: ['xls', 'xlsx', 'txt', 'doc', 'docx', 'pdf', 'jpg'],
        rules: {
          cause: [
            { required: true, message: '原因必填', trigger: 'blur' },
            { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' },
          ],
        },
        title: '关闭合同',
        label: '关闭原因',
        url: '',
      };
    },
    methods: {
      openDialog({ ids, status }) {
        if (status == 'close') {
          this.title = '关闭合同';
          this.label = '关闭原因';
          this.url = API.CLOSE_LEASE_CONTRACT;
        }
        if (status == 'enable') {
          this.title = '启用合同';
          this.label = '启用原因';
          this.url = API.ENABLE_LEASE_CONTRACT;
        }
        if (status == 'suspend') {
          this.title = '暂停合同';
          this.label = '暂停原因';
          this.url = API.SUSPEND_LEASE_CONTRACT;
        }
        this.dialogVisible = true;
        this.ids = ids;
      },
      // 关闭弹窗
      closeDialog() {
        this.$refs.closeReasonForm.resetFields();
        this.$refs.upload.clearFiles();
        this.baseInfoData.attachments = [];
      },
      // 取消
      handleCancel() {
        this.dialogVisible = false;
        this.$emit('resetCheckbox');
      },
      // 关闭确认
      async handleSure() {
        if (!this.baseInfoData.cause) {
          this.$message.error('请完成必填项填写');
          return;
        }
        const params = {
          ids: this.ids,
          fileList: this.baseInfoData.attachments,
          cause: this.baseInfoData.cause,
        };
        this.$axios.post(this.url, params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg || '操作成功',
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
          this.dialogVisible = false;
          this.$parent.getData();
          this.$emit('resetCheckbox');
        });
      },
      // 文件上传方法
      beforeUpload(file) {
        console.log('文件', file);
        const { name, size } = file;
        // 文件格式化校验
        if (this.fileType.length) {
          const supportFileType = this.fileType?.join('|');
          const fileExtname = path.extname(name).substring(1);
          console.log(supportFileType, fileExtname);
          if (!new RegExp('(' + supportFileType + ')', 'i').test(fileExtname)) {
            this.$message.warning(`文件格式不正确,只能上传${this.fileType}其中一种`);
            return false;
          }
        }
        if (this.fileSize > 0) {
          // 文件大小
          if (size > this.fileSize * 1024 * 1024) {
            this.$message.warning(`文件过大,请上传小于${this.fileSize}MB的文件`);
            return false;
          }
        }
        return true;
      },
      // 上传时
      handleProgress(event, file, fileList) {
        console.log(event, file, fileList, '文件上传时');
        this.loading.startLoading('正在上传中....');
      },
      //上传成功
      handleSuccess(res, file) {
        this.loading.endLoading();
        if (res.code === 0) {
          let obj = {
            attachmentName: file.name,
            createBy: this.userInfo.userName,
            gmtCreate: this.todayDate,
            attachmentPath: res.data.attachmentPath,
            attachmentKey: res.data.attachmentKey,
          };
          // this.attachments =this.attachments.push(obj);
          this.uploadHandler && this.uploadHandler(obj);
          this.$message.success('上传成功');
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      },
      uploadChange(_, fileList) {
        this.viewFileList = fileList;
      },
      handlePreview(file) {
        window.open(file.response.data.attachmentPath, '_blank');
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
        this.baseInfoData.attachments = this.baseInfoData.attachments.filter((item) => {
          return item.attachmentKey != file.response.data.attachmentKey;
        });
        console.log('移除', this.baseInfoData.attachments, file.response.data.attachmentKey);
      },
      // 上传成功回调
      uploadHandler(fileObj) {
        this.baseInfoData.attachments.push({
          attachmentName: fileObj.attachmentName,
          createBy: fileObj.createBy,
          gmtCreate: XEUtils.toDateString(new Date(), 'yyyy-MM-dd HH:mm:ss'),
          attachmentKey: fileObj.attachmentKey,
          // attachmentId: fileObj.attachmentId,
          attachmentPath: fileObj.attachmentPath,
        });
      },
    },
    mounted() {
      this.actionUrl = baseUrl + dataBaseAPI.OSS_UPLOAD_API;
    },
  };
</script>

<style></style>
